import {isPositive, isPositiveZero} from 'ramda-adjunct';

export const isValidIndex = (val: number) => isPositive(val) || isPositiveZero(val);
